// src/components/BannerWithCard_DAO.js
import React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: relative;
  padding: 4% 0px 0px 0px;
  background-color: #000000;
  text-align: center;
  max-width: 100%;

  img {
    max-width: 100%; /* 調整圖片最大寬度 */
    height: auto; /* 確保高度按比例縮放 */
  }

  h1 {
    position: absolute;
    top: 25%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 52px;
    line-height: 75px;
    font-weight: 700;
    letter-spacing: 0.05em;
    color: #FFFFFF;
  }

  .overlay {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 50%;
    height: 50%;
    background: rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 20px rgba(182, 176, 95, 0.4);
    border-radius: 30px 30px 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    
  }

  .title {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 43px;
    letter-spacing: 0.05em;
    color: #FFF56A;
    padding: 0% 0% 0% 5%;
  }

  .description {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 32px;
    color: #EFEFEF;
    
    padding: 2.5% 5% 0% 5%;
    text-align: left;
  }

  @media (max-width: 500px) {
    padding: 2% 0px 50% 0px;

    h1 {
      font-size: 36px;
      line-height: 52px;
      
    }

    .overlay{
      left: 50%;
      width: 90%;
      height: 50%;


    }

    .title {
      font-size: 20px;
      line-height: 29px;
      padding: 10% 0% 0% 5%;
      

    }

    .description {
      font-size: 14px;
      line-height: 24px;
      padding-bottom:10%;
    }
  }
`;

const DesktopBanner = styled.img`
  display: block;

  @media (max-width: 500px) {
    display: none;
  }
`;

const MobileBanner = styled.img`
  display: none;
  width: 100%;
  
  @media (max-width: 500px) {
    display: block;

    
  }
`;

const BannerWithCard_DAO = () => (
  <BannerContainer>
    <DesktopBanner src="/images/pages_banner.png" alt="Desktop Banner" />
    <MobileBanner src="/images/pages_banner_mobile.png" alt="Mobile Banner" />
    <h1>分散式自治組織</h1>
    <div className="overlay">
      <div className="title">DAO 是什麼？</div>
      <div className="description">
        分散式自治組織為一種集體擁有、由區塊鏈協助治理，並致力於達成共同使命的組織。<br/><br/>組織擁有自己的資金庫，未經團體核准，任何人都無權單獨使用。 每項決策都是經由提案和投票來治理，並確保每位組織成員都能發聲，且行為紀錄都是上鏈且公開透明且不可竄改的。
      </div>
    </div>
  </BannerContainer>
);

export default BannerWithCard_DAO;
